import axios from "axios";

export const baseUrl = "https://api.arnetworks.app/api";
// export const baseUrl = "https://card.khaledjamal.com/api";
// export const baseUrl = "https://cc.khaledjamal.com/api";

axios.interceptors.request.use(
  (config) => {
    config.baseURL = baseUrl;

    config.headers = {
      Authorization: `Bearer ${
        JSON.parse(localStorage.getItem("token")) || false
      }`,
      Accept: "application/json",
    };
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error.response.status === 401) {
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("user_info");
    //   router.push({ name: "login" });
    return Promise.reject(error);
  }
);

export default axios;
